import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/filter'
import 'aos/dist/aos.css';
import AOS from 'aos';
import ElementUI from 'element-ui';
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
AOS.init({
	easing: 'ease-in-out-sine',
	offset: 200,
	delay: 100,
	duration: 500
});

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
